<template>
	<v-container class="login-container">
		<v-layout class="login_background" flex-wrap justify-center>
			<v-flex xs12>
				<div :style="`background-color: ${$store.state.PointColor1};`" style="max-width:600px; margin:0 auto; height: 100vh;" class="pt-6">
					<v-card class="waitingCheck pa-4 mb-0" elevation="0">
						<div class="reserveCheck-header-text my-2">
							상담신청 QR
						</div>
					</v-card>
					<div class="waitingCheck-dash" :style="$vuetify.breakpoint.xs ? 'max-width:85%;' : ''"></div>
					<v-card class="waitingCheck mt-0 px-4 pt-8 pb-6" elevation="5" v-if="reserveusersData">
						<vue-qrcode :value="qrCodeData" class="qr-code" />
						<div class="mt-7 px-2 text-center">
							<div class="reserveCheck-text-3">
								▶ 상담신청- [대기번호]가 지나가면 재신청이 필요하며, 추가 대기시간이 발생하오니 알림톡 또는 문자를 꼭 확인하시기 바랍니다.
							</div>
							<!-- <div class="reserveCheck-text-3">
								▶ 음료교환- 1인당 1회 교환이 가능합니다(동반인 제공)
							</div> -->
						</div>
					</v-card>
					<v-card class="waitingCheck mt-0 px-4 pt-8 pb-6" elevation="5" v-else>
						<v-layout class="px-2">
							<div class="reserveCheck-text-1 pt-1">
								방문등록을 하지않은 고객입니다. <br />
								방문등록 부터 진행 후 알림톡을 통하여 QR을 확인해 주세요.
							</div>
						</v-layout>
					</v-card>
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import VueQrcode from 'vue-qrcode'
export default {
	components: {
		VueQrcode,
	},
	metaInfo() {
		return {
			title: '상담신청 실시간 체크',
			socket: null,
		}
	},
	mounted() {},
	data() {
		return {
			statText: '',
			noData: false,
			countDown: 0,
			userInfo: { name: '', cdate: '', waitingnum: '' }, // 고객 waiting 정보
			frontnum: 0, //현재 대기자 수
			closeBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn',
				color: this.$store.state.PointColor1,
			},
			nextBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn',
				color: this.$store.state.PointColor1,
			},
			realWait: '', // 신청 유무
			nowaitUser: { show: false }, // 예약 없을 시 고객 데이터
			alertModal: {
				dialog: false,
				text: '',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			screenWidth: window.innerWidth,
			reservedaysData: {},
			socket: '',
			reserveusersData: null,
			qrCodeData: null,
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	async created() {
		await this.reserveusers()
	},
	methods: {
		async reserveusers() {
			this.$store.state.loading = true
			const data = {
				code: this.$route.params.code,
				phone: this.$route.params.phone,
			}
			await this.$store
				.dispatch('reserveusers', data)
				.then(res => {
					this.$store.state.loading = false

					// 한국 시간 기준 오늘 날짜 (YYYY-MM-DD 형식)
					const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' }))
					const todayStr = today.toISOString().split('T')[0]

					// rdate가 오늘 날짜인 데이터만 필터링
					const todayReservation = res.data.reserveusers.find(item => {
						if (item && item.rdate) {
							const rdate = new Date(item.rdate).toISOString().split('T')[0]
							return rdate === todayStr
						}
						return false
					})
					if (todayReservation) {
						this.qrCodeData = `${todayReservation.phone}/${todayReservation.rdate}`
					} else {
						this.qrCodeData = null
					}
					this.reserveusersData = todayReservation || null
				})
				.catch(err => {
					this.$store.state.loading = false
					console.log(err)

					this.alertModal.dialog = true
					this.alertModal.text = '서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해주세요.'
				})
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
	},
}
</script>

<style lang="scss" scoped>
html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
li,
dl,
dt,
dd,
table,
th,
td,
form,
fieldset,
legend,
input,
textarea,
button {
	font-family: 'Noto Sans KR', 'Apple SD Gothic Neo';
	margin: 0;
	padding: 0;
	letter-spacing: -1px;
}
li {
	list-style: none;
}
img,
fieldset {
	border: none;
	margin: 0;
	padding: 0;
}
</style>
<style>
.qr-code {
	height: 250px;
}
</style>
